import emojiPC from './emojiPC.vue';
export default emojiPC;
